import logo from '../images/logo.png';
import SpinWheel from './SpinWheel';

const Header = () => (
  <header>
    <div className="header-bg"></div>
    <div className="container wheel-container text-center">
      <img src={logo} alt="Race to Gem Mountain" id="logo" />
      <h1>Welcome to Gem Mountain. Do you have what it takes to make it to the top?</h1>
      <h2 className="text-uppercase">Spin the wheel to receive your challenge!</h2>
      <SpinWheel />
    </div>
  </header>
);

export default Header;
